import { CommonParams, addFreeSegment, addPathFragment, isPureQueryUrl } from './SEOPathModule/convertParamsToPath';

const appendCommonParams = (href: string, commonParams: CommonParams = {}) => {
  const url = new URL(href || '/', 'http://example.com');

  for (const key in commonParams) {
    const typedKey = key as keyof CommonParams;
    const val = commonParams[typedKey];

    if (typedKey === 'isFree') {
      continue;
    }

    if ((typedKey === 'minPrice' || typedKey === 'maxPrice') && commonParams.isFree === true) {
      continue;
    }

    if (val !== undefined && val !== null) {
      url.searchParams.set(typedKey, String(val));
    }
  }

  let result = url.pathname + url.search + url.hash;

  if (commonParams.isFree === true) {
    result = addFreeSegment(result);
  } else if (isPureQueryUrl(result) && url.search) {
    result = addPathFragment(result, '/search');
  }

  return result;
};

export const getLink = (categoryLink: string, searchHref: string, commonParams: CommonParams = {}) => {
  const normalized = categoryLink.replace(/^\/+/g, '').replace(/\/+$/g, '');
  const baseHref = normalized
    ? searchHref
      ? `/${searchHref}/${normalized}`
      : `/${normalized}`
    : searchHref
      ? `/${searchHref}`
      : '/';

  return appendCommonParams(baseHref, commonParams);
};
